import React, {useContext} from 'react'
import LanguageContext from "./../contexts/languageContext.js"


const QTitle = (props) => {
    const { rtl} = useContext(LanguageContext);

    return <div className={`${rtl ? "text-end" : ""} d-block mb-1 fs-4 px-1`} >{props.children}</div>
}


export default QTitle